import React from "react";

import googleplay from "./../../assets/google_play.png";
import appstore from "./../../assets/app_store.svg";
import { AOSProps } from "../../global/types";

export const DownloadIcons: React.FC<AOSProps> = ({
  dataAos,
  dataAosDelay
}) => {
  return (
    <div
      className="download-icons"
      data-aos={dataAos}
      data-aos-delay={dataAosDelay}
    >
      <a href="https://play.google.com/store/apps/details?id=de.uniklinik_freiburg.meine_uniklinik" target="_blank" rel="noreferrer">
        <img src={googleplay} alt="Google Play Icon" />
      </a>
      <a href="https://apps.apple.com/de/app/meine-uniklinik/id1506171144" target="_blank" rel="noreferrer">
        <img src={appstore} alt="App Store Icon" />
      </a>
    </div>
  );
};
